import { Icon } from "Components";
import React from "react";

interface EmptyStateProps {
    title: string;
    description: string;
    actionLabel?: string;
    onAction?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({
    title,
    description,
    actionLabel = "Create Campaign",
    onAction,
}) => {
    return (
        <div className="pm-empty-card">
            <div>
                <Icon type="noCampaign" />
                <div className="pm-empty-title">{title}</div>
            </div>
            <div className="pm-empty-description">
                {description}
            </div>
            <div className="pm-empty-button-wrapper">
                <button
                    className="pm-empty-button"
                    onClick={onAction}
                >
                    {actionLabel}
                </button>
            </div>
        </div>
    );
};

export default EmptyState;